import { render, staticRenderFns } from "./GestionBonoExport.vue?vue&type=template&id=2ab255b4"
import script from "./GestionBonoExport.vue?vue&type=script&lang=js"
export * from "./GestionBonoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports